// extracted by mini-css-extract-plugin
module.exports = {"legalLinks":"legalLinks__3AfY9","link":"link__3rDmd"};